import { Row } from "antd";
import { useMemo } from "react";
import { EmptyList } from "../../Chat/components/EmptyList";

export const NoMessageFound = () => {
  const emptyListData = useMemo(
    () => ({
      title: "No messages found",
      subTitle: "Try changing the filters.",
    }),
    []
  );

  return (
    <Row className="w-100 justify-center">
      <EmptyList data={emptyListData} />
    </Row>
  );
};
